module.exports = __webpack_public_path__ + "img/special-subject-title.231e939d.jpg";